<template>
  <section>
    <section-header :current="current" />
    <contrato :current="current" :auto="auto"/>
  </section>
</template>

<script>
import SectionHeader from '@/components/matriculas/4/template/SectionHeader.vue'
import Contrato from '@/components/matriculas/form/Contrato.vue'

export default {
  components: {
    SectionHeader, Contrato
  },
  props: {
    current: Object,
    auto: Boolean
  },
  data () {
    return {
      
    }
  },
  mounted () {

  }
}
</script>

<style>

</style>